module.exports = __webpack_public_path__ + "img/construction-contract-4.979b6e34.jpg";